import LabourDemandPulseTab from './LabourDemandPulseTab';

export default LabourDemandPulseTab;
